import React from 'react';
import styled from 'styled-components';
import __ from '../utils/translator';
import ArrowUp from '../icons/ArrowUp';

function handleOnClick(event) {
  event.preventDefault();
  window.scrollTo(0, 0);
}

export default props => (
  <Footer {...props}>
    <Button onClick={handleOnClick}>
      <ArrowUp style={{ display: 'inline', }} />
      <span>{__('Go to top')}</span>
    </Button>
  </Footer>
);

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4.5rem;
  background-color: ${props => props.theme.secondaryBackgroundColor};
`;

const Button = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: auto;
  margin-left: auto;
  color: #fff;
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
  text-transform: uppercase;
  font-size: .875rem;

  svg {
    width: 1.5rem;
    margin-right: auto;
    margin-bottom: .5rem;
    margin-left: auto;
  }
`;
